module.exports = __webpack_public_path__ + "img/cons_1.4fa2b41b.jpg";